<template>
  <v-card>
    <v-toolbar :dense="true"  v-if="mode !== 'query'">
      <v-toolbar-title class="body-2"> <v-icon>mdi-file-document-box</v-icon> XOL Worksheets </v-toolbar-title>
      <v-spacer />
      <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
    </v-toolbar>
    <X-O-L-Recovery-Listing :clmNo="clmNo" />
    <v-card-actions v-if="mode !== 'query'">
      <v-spacer />
      <v-btn color="red darken-1" text @click.native="doCancel">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import XOLRecoveryListing from '@/components/core/claimManagement/xolRecovery/XOLRecoveryListing'
export default {
  props: {
    mode: {
      type: String,
      default: 'review'
    }
  },
  components: {
    XOLRecoveryListing
  },
  data() {
    return {}
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    clmNo() {
      return (this.commonInfo || {}).clmNo
    }
  },
  methods: {
    doCancel() {
      this.$emit('close')
    }
  }
}
</script>
